module.exports = __webpack_public_path__ + "static/media/virtual-showroom-1960x1200.9fb62771.jpg";